













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import { User } from 'frontend/types';
import AppFooter from 'frontend/components/AppFooter.vue';
import AppHeader from 'frontend/components/AppHeader.vue';
import Banner from 'frontend/components/Banner.vue';

import { setDesktopCssBodyClass, setMobileCssBodyClass } from 'frontend/utils/dom';

@Component({
  components: {
    AppFooter,
    AppHeader,
    Banner,
    // Don't load these until we actually need to display them
    PrivacyBanner: () =>
      // tslint:disable-next-line:space-in-parens
      import(/* webpackChunkName: 'PrivacyBanner' */ 'frontend/views/global/PrivacyBanner.vue'),
    SignupModal: () =>
      // tslint:disable-next-line:space-in-parens
      import(/* webpackChunkName: 'SignupModal' */ 'frontend/components/SignupModal.vue'),
  },
  computed: {
    ...mapState('signupModal', ['signupModalIsVisible']),
    ...mapState('globals', ['user']),
    ...mapGetters('globals', ['privacyProperties']),
  },
})
export default class AppDesktop extends Vue {
  @Prop(Boolean) private readonly shouldHideHeader!: boolean;
  private readonly user!: User;
  private readonly signupModalIsVisible!: boolean;
  private blurred = false;

  private get shouldShowSignupModal(): boolean {
    return !this.user.is_authenticated && this.signupModalIsVisible;
  }

  private mounted(): void {
    setDesktopCssBodyClass();
    // testing Sentry
    if (process.env.VUE_ENV !== 'server') {
      if ('breakvue' in this.$route.query) {
        (window as any).breakMe();
      }
    }
    this.$nextTick(() => {
      this.$emit('mounted');
    });
  }

  private destroyed(): void {
    setMobileCssBodyClass();
  }
}
